import { render } from "./Tandas.vue?vue&type=template&id=8e096fb4"
import script from "./Tandas.vue?vue&type=script&lang=js"
export * from "./Tandas.vue?vue&type=script&lang=js"

import "./Tandas.vue?vue&type=style&index=0&id=8e096fb4&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__